import { keysToSnake } from '#/api/adapters/wireCase';

function toNumberOrNull(value) {
  if (value === '' || value == null) {
    return null;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

function emptyToNull(value) {
  if (value == null) {
    return null;
  }
  const trimmed = String(value).trim();
  return trimmed === '' ? null : trimmed;
}

/** 用料：`{id?, inventory_stock_id, qty, unit_id}`；快照由後端依來源推導，不送。 */
function mapMaterials(rows = []) {
  return (rows ?? []).map((row) => {
    const item = {
      inventoryStockId: row?.inventoryStockId,
      qty: toNumberOrNull(row?.qty),
      unitId: row?.unitId,
    };
    return row?.id ? { id: row.id, ...item } : item;
  });
}

/**
 * POST `/mom/work-order-repair`：workOrderId、problemQty（>0）、problemDescription 必填。
 */
export function serializeWorkOrderRepairCreate(values = {}) {
  return keysToSnake({
    workOrderId: values.workOrderId,
    problemQty: toNumberOrNull(values.problemQty),
    repairedQty: toNumberOrNull(values.repairedQty) ?? 0,
    notRepairedQty: toNumberOrNull(values.notRepairedQty) ?? 0,
    problemDescription: emptyToNull(values.problemDescription),
    handlingDescription: emptyToNull(values.handlingDescription),
    remark: emptyToNull(values.remark),
    materials: mapMaterials(values.materials),
  });
}

/**
 * PATCH `/mom/work-order-repair/{id}`（僅 OPEN）：partial；
 * 必帶 `updatedAt`（record.updated_at）＋`revision`；`materials` 出現＝整批取代。
 */
export function serializeWorkOrderRepairUpdate(values = {}) {
  const payload = {
    problemQty: toNumberOrNull(values.problemQty),
    repairedQty: toNumberOrNull(values.repairedQty) ?? 0,
    notRepairedQty: toNumberOrNull(values.notRepairedQty) ?? 0,
    problemDescription: emptyToNull(values.problemDescription),
    handlingDescription: emptyToNull(values.handlingDescription),
    remark: emptyToNull(values.remark),
    updatedAt: values.updatedAt,
    revision: values.revision,
  };
  if (Array.isArray(values.materials)) {
    payload.materials = mapMaterials(values.materials);
  }
  return keysToSnake(payload);
}

/** close：`{updated_at, revision}` */
export function serializeWorkOrderRepairVersion(values = {}) {
  return keysToSnake({ updatedAt: values.updatedAt, revision: values.revision });
}

/** 更正：`{reason, material_ids}`；無用料的維修單送 `[]`。 */
export function serializeWorkOrderRepairCorrection(values = {}) {
  return keysToSnake({
    reason: emptyToNull(values.reason),
    materialIds: (values.materialIds ?? []).filter(Boolean),
  });
}
